module.exports = __webpack_public_path__ + "412b31ba61b11ba5c6b67f81facc490b.svg";